import { AgentInnerContact } from './poi-agent-inner';

export default AgentInnerContact;
